import { isEqual } from 'lodash';

import { FoodTrayTemplate } from '../../models';
import { AppState } from '../rootReducer';

export const getCurrentFoodTrayTemplate = (state: AppState): Partial<FoodTrayTemplate> =>
  state.foodTrayTemplateEdit?.currentFoodTrayTemplate;
export const hasUnsavedChanges = (state: AppState): boolean =>
  !isEqual(state.foodTrayTemplateEdit.currentFoodTrayTemplate, state.foodTrayTemplateEdit.initialFoodTrayTemplate);
